<template>
  <suspense>
    <ContentfulRenderer :component="ContentPage" :content-type="'campaignPage'" :slug="slug" :activeOf="'Homepage'" :isRequired="false" :isCritical="true">
      <template v-slot:default="slotProps">
        <HomepageMeta v-bind="slotProps"/>
      </template>
      <template v-slot:fallback>
        <ContentfulRenderer :component="ContentPage" :content-type="'campaignPage'" :activeOf="'Fallback Homepage'" :isRequired="true" :isCritical="true">
          <template v-slot:default="slotProps">
            <HomepageMeta v-bind="slotProps"/>
          </template>
        </ContentfulRenderer>
      </template>
    </ContentfulRenderer>
  </suspense>
</template>

<script>
import ContentfulRenderer from './ContentfulRenderer.vue';
import ContentPage from '@/components/contentful/ContentModels/ContentPage.vue';
import { useRouter } from 'vue-router';
import { computed } from 'vue';
import HomepageMeta from "./HomepageMeta.vue"
export default {
  name: 'Homepage',
  components: {
    ContentfulRenderer,
    HomepageMeta
  },
  setup() {
    const router = useRouter();
    const slug = computed(() => router.currentRoute.value.params?.slug);
    return {
      ContentPage,
      slug,
    };
  },
};
</script>

<style lang="postcss"></style>
